import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { CRMListObjectsType } from "app/pages/sales-intelligence/sub-modules/management/types";
import { allTrackers } from "app/services/track/track";

export const makeCrmSyncTrackingService = ({
    crm,
    objectsType,
}: {
    crm: Integration | undefined;
    objectsType: CRMListObjectsType;
}) => {
    const objectsTypeToName: Record<CRMListObjectsType, string> = {
        accountsAndLeads: "accounts and leads",
        accounts: "accounts",
        leads: "leads",
        contacts: "contacts",
        accountsAndContacts: "companies and contacts",
    };

    const getObjectTypesName = (objectsType: CRMListObjectsType) => {
        if (crm === "hubspot" && objectsType === CRMListObjectsType.Accounts) {return "companies";}

        return objectsTypeToName[objectsType];
    };

    const trackIsCrmListEnabledChange = (newIsEnabled: boolean) => {
        const action = newIsEnabled ? "enable" : "disable";

        const subName = getObjectTypesName(objectsType);
        const subSubName = newIsEnabled ? "on" : "off";

        allTrackers.dispatchTrackEvent(`${crm} integration`, `${action} monitor`, `monitor/${subName}/${subSubName}`);
    };

    const trackObjectsTypeChange = (newObjectsType: CRMListObjectsType) => {
        const subSubName = getObjectTypesName(newObjectsType);
        allTrackers.dispatchTrackEvent(
            `${crm} integration`,
            "select object to monitor",
            `monitor/${crm} accounts/${subSubName}`,
        );
    };

    return { trackIsCrmListEnabledChange, trackObjectsTypeChange };
};
